<ng-container [formGroup]="formParent" *ngIf="!isPaymentList">
    <div class="form-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">        
        <label class="class_label" [for]="frmControl" *ngIf="isLabelTop">{{label}}</label>
        <div class="select-wrapper" [class.open]="isOpen">
            <select #selectElement class="form-control" [formControlName]="frmControl" 
                    data-placeholder="placeHolder" tabindex="1" 
                    [(ngModel)]="control.value" 
                    (change)="optionSelected($event.target.value)">
                <option [ngValue]="null" disabled>Selecciona una opción</option>
                <option [ngValue]="option.name" *ngFor="let option of options" 
                        [selected]="option.name === control.value">{{option.name ? option.name : option.description}}</option>
            </select>
            <i class="fa" [ngClass]="isOpen ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </div>
          
          
        <label class="form-label" [for]="frmControl" *ngIf="!isLabelTop">{{label}}</label>
    </div>

</ng-container>

<ng-container [formGroup]="formParent" *ngIf="isPaymentList">
    <div class="form-group">        
        <label class="class_label" [for]="frmControl" *ngIf="isLabelTop">{{label}}</label>
        <div class="select-wrapper" [class.open]="isOpen">
            <select #selectElement class="form-control" [formControlName]="frmControl" 
                    data-placeholder="placeHolder" tabindex="1" 
                    [(ngModel)]="control.value" 
                    (change)="optionSelected($event.target.value)">
                <option [ngValue]="null" disabled>Selecciona una opción</option>
                <option [ngValue]="option._id" *ngFor="let option of options" 
                        >{{option.name}}</option>
            </select>
            <i class="fa" [ngClass]="isOpen ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </div>
        <label class="form-label" [for]="frmControl" *ngIf="!isLabelTop">{{label}}</label>
    </div>

</ng-container>

<ng-container *ngIf="control?.dirty && control?.invalid">
    <span class="help-block" *ngFor="let errorMessage of control['errorMessages']"> {{errorMessage}} </span>
    <span class="help-block" *ngIf="control.errors.async"> {{control.errors.async}} </span>
</ng-container> 